<template>
    <path fill-rule="evenodd" d="M6.895 5l2.843-2.843c.35-.349.35-.914 0-1.264L9.107.262c-.35-.35-.915-.35-1.264 0L5 3.105 2.157.262c-.349-.35-.914-.35-1.264 0L.262.893c-.35.35-.35.915 0 1.264L3.105 5 .262 7.843c-.35.349-.35.914 0 1.264l.631.631c.35.35.915.35 1.264 0L5 6.895l2.843 2.843c.349.35.915.35 1.264 0l.631-.631c.35-.35.35-.915 0-1.264L6.895 5z"/>
</template>

<script>
export default {
    name: 'closeV2Icon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 10 10');
    }
}
</script>

<style scoped>

</style>